import { useIntl } from 'react-intl'
import { useRouter } from 'solito/router'

import useNativeModalRedirect from 'app/hooks/useNativeModalRedirect'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'
import { USER_ROLE, userRoleText } from 'app/utils/constants/role.constants'

interface UseContactSellerProps {
  role?: string
  chatId?: string
  isOwner?: boolean
}

export const useContactSeller = ({
  chatId,
  isOwner,
  role
}: UseContactSellerProps) => {
  const intl = useIntl()

  const { push } = useRouter()
  const { redirectToModal } = useNativeModalRedirect()

  const listingIdPath = isOwner ? '' : `?listingId=${chatId}`
  const path = '/profile/messages' + listingIdPath

  const userRole = role || USER_ROLE.PERSONAL

  const chipText = intl.formatMessage(userRoleText[userRole])

  const contactSellerHandler = () => {
    if (IS_NATIVE_APP) {
      const isOpenChat = !isOwner && !!chatId

      redirectToModal({
        name: 'profile/messages',
        ...(isOpenChat && { params: { listingId: chatId } })
      })

      return
    }

    push(path)
  }

  return { contactSellerHandler, chipText }
}
